const DIALOG_NAMES = {
  LOG_IN_ADMIN: "log-in-admin",
  CONFIRM_CODE: "confirm-code",
};

export default DIALOG_NAMES;
